import { CrudChartRenderData } from "@/modules/Dashboards/AdminDashboard/models/CrudChartRenderData";

export const CHART_EVENTS = {
  CHANGE_CHART_TYPE: "changeChartType",
  CLICK: "clickData",
  CLICK_OUT: "clickOut"
};

export const CHART_INIT: CrudChartRenderData = {
  chartTitle: "",
  chartRenderData: {
    labels: [],
    datasets: [
      {
        data: []
      }
    ]
  }
};
